import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";

const HeaderBackToBlog = () => {
  return (
    <div className="headerback">
      <Link to={"/blog"} style={{ textDecoration: "none" }}>
        <div className="backhome" />
      </Link>
    </div>
  );
};

export default HeaderBackToBlog;
